var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-card",attrs:{"data-table":"SUMMARY"}},[_c('div',[_vm._v(_vm._s(_vm.fitem.subject.short_summary||"无简介内容"))]),_c('hr'),_c('div',[_vm._v(_vm._s(_vm.fitem.comment||"无个人点评"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }